import { createContext } from 'react';

import type { TickAxis } from '../../core/utils/formatter-by-ticks.js';

export interface HistogramTickAxis {
  left: TickAxis;
  bottom: TickAxis;
  right?: TickAxis;
}

export const HistogramTickAxisContext = createContext<
  HistogramTickAxis | undefined
>(undefined);

HistogramTickAxisContext['displayName'] = 'HistogramTickAxisContext';
